export { default as UiRotatingImages } from "./UiRotatingImages";
